import { Component } from "@angular/core";

@Component({
    selector: "error-component",
    template: require("./error.component.html")
})

export class ErrorComponent {
    errorMessage: string;
    constructor() {
        this.errorMessage = "";
     }

    public ngOnInit() { }
}


// WEBPACK FOOTER //
// ./src/app/components/error/error.component.ts